const reloadParam = "_mux_reload"

function cacheBustedReloadURL(href: string, nonce = Date.now()) {
  const url = new URL(href)
  url.searchParams.set(reloadParam, nonce.toString(36))
  return url.toString()
}

export function reloadWithCacheBust() {
  window.location.replace(cacheBustedReloadURL(window.location.href))
}
